import React from 'react'
import { Card } from 'react-bootstrap'
import img from '../../assests/images/piles-coins-with-plant-front-graph.jpg';
import { useSelector } from 'react-redux'
import CurrencyConverter from '../../Currency/CurrencyConverter';
import LazyLoad from 'react-lazyload';


function ActiveInvest({ investPlanDeatils, t }) {
    const userSelectedCurrency = useSelector(
        (state) => state.user?.selectedCurrency
    );
    const conversionFactor = useSelector(
        (state) => state?.user?.conversionFactor
    );
    return (
        <div>
            <Card className='active-invest-card'>
                <Card.Body className='p-0'>
                    <div className='row no-gutters'>
                        <div className='col-lg-6'>
                            <LazyLoad height={200} offset={100} once>
                                <Card.Img src={img} />
                            </LazyLoad>
                        </div>
                        <div className='col-lg-6'>
                            <div className='info-section'>
                                <div className='info-content'>
                                    <h1 style={{ textTransform: 'uppercase' }}>{t('activeInvestDetails')}</h1>
                                    <ul style={{ listStyleType: 'square' }}>

                                        {
                                            investPlanDeatils &&
                                            investPlanDeatils.map((items, index) => {
                                                return (
                                                    <React.Fragment key={index}>
                                                        <li>{t('investPlan')} : {items.name}</li>
                                                        <li>{t('investedAmount')} : {userSelectedCurrency?.symbolLeft}{" "}
                                                            {CurrencyConverter(
                                                                parseInt(items.investAmount),
                                                                conversionFactor
                                                            )}
                                                        </li>
                                                        <li>{t('lnvestmentPeriod')} : {items.days}</li>
                                                        <li>{t('roi')} : {items.roi} %</li>
                                                    </React.Fragment>

                                                )
                                            })
                                        }
                                    </ul>
                                </div>

                            </div>
                        </div>
                    </div>
                </Card.Body>
            </Card>
        </div>
    )
}

export default ActiveInvest